const baseUrl = process.env.VUE_APP_BASE_URL

/**
 * 系统通用接口
 */
export const dictionaryUrl = `${baseUrl}/blade-system/dict-biz/dictionary` // 获取业务字典
export const dictByKeywordUrl = `${baseUrl}/blade-system/dict-biz/list` // 根据关键字查询字典
export const putFileUrl = `${baseUrl}/blade-resource/oss/endpoint/put-file` // 文件上传
export const getTimeStampUrl = `${baseUrl}/blade-business/project/getCurrentTime` // 获取网络时间戳

/**
 * 注册接口
 */
export const registerCompanyUrl = `${baseUrl}/blade-tw-recruit/common/account/company/register` // 企业注册
export const registerIndividualUrl = `${baseUrl}/blade-tw-recruit/common/account/individual/register` // 个人注册

/**
 * 门户首页接口
 */
export const newestNewsListUrl = `${baseUrl}/blade-tw-recruit/common/portal/news/newest` // 获取最新新闻列表(用于首页右侧轮播图)
export const linkListUrl = `${baseUrl}/blade-tw-recruit/common/portal/link/list` // 分页查询友情链接
export const slideShowListUrl = `${baseUrl}/blade-tw-recruit/common/portal/slideshow/list` // 轮播图列表
export const newestInfoListUrl = `${baseUrl}/blade-tw-recruit/common/portal/information/newest` // 获取最新资讯列表(用于首页右侧轮播图)
export const introduceUrl = `${baseUrl}/blade-tw-recruit/common/portal/competentOrganization/detail` // 获取公司介绍
export const getRecruitPostCompanyListUrl = `${baseUrl}/blade-tw-recruit/common/portal/company/getRecruitPostCompanyList` // 获取在招企业列表
export const getRecruitPostListUrl = `${baseUrl}/blade-tw-recruit/common/portal/post/companyRecruitPostList` // 公司主页 获取公司在招岗位
/**
 * 岗位列表页
 */
export const jobListUrl = `${baseUrl}/blade-tw-recruit/common/portal/post/page` // 分页查询岗位列表
export const jobDetailUrl = `${baseUrl}/blade-tw-recruit/common/portal/post/detail` // 获取岗位详情
export const companyDetailByIdUrl = `${baseUrl}/blade-tw-recruit/common/portal/company/detail` // 根据公司id查询公司详情
export const individualPostCollectUrl = `${baseUrl}/blade-tw-recruit/individual/post/collect` // 个人 收藏岗位
export const individualPostCancelCollectUrl = `${baseUrl}/blade-tw-recruit/individual/post/cancelCollect` // 个人 取消收藏岗位
export const individualSendResumeUrl = `${baseUrl}/blade-tw-recruit/individual/sendResume/send` // 个人 岗位投递简历
export const findAccountResumesUrl = `${baseUrl}/blade-tw-recruit/individual/resume/findAccountResumes` // 查找登录用户的所有简历

/**
 * 新闻
 */
export const newsListUrl = `${baseUrl}/blade-tw-recruit/common/portal/news/page` // 分页查询新闻列表
export const newsDetailUrl = `${baseUrl}/blade-tw-recruit/common/portal/news/detail` // 获取新闻详情
export const newsListByBriefUrl = `${baseUrl}/blade-tw-recruit/common/portal/news/listByBrief` // 全量简略数据(上一页，下一页)

/**
 * 资讯
 */
export const infoListUrl = `${baseUrl}/blade-tw-recruit/common/portal/information/page` // 分页查询资讯列表
export const infoDetailUrl = `${baseUrl}/blade-tw-recruit/common/portal/information/detail` // 获取资讯详情
export const infoListByBriefUrl = `${baseUrl}/blade-tw-recruit/common/portal/information/listByBrief` // 全量简略数据(上一页，下一页)

/**
 * 企业端接口
 */
export const companyDetailUrl = `${baseUrl}/blade-tw-recruit/company/detail` // 获取单位详情
export const companyModifyUrl = `${baseUrl}/blade-tw-recruit/company/updateCompanyDetail` // 修改单位信息
export const companyUploadAvatarUrl = `${baseUrl}/blade-tw-recruit/company/account/uploadAvatar` // 企业上传头像
export const companyAccountDetailUrl = `${baseUrl}/blade-tw-recruit/company/account/detail` // 企业上传头像

export const postListUrl = `${baseUrl}/blade-tw-recruit/company/post/page` // 分页查询岗位列表
export const postListByCompanyUrl = `${baseUrl}/blade-tw-recruit/company/post/companyRecruitPostList` // 根据当前登录企业-分页查询岗位列表
export const postSaveUrl = `${baseUrl}/blade-tw-recruit/company/post/temporary` // 保存岗位
export const postPublishUrl = `${baseUrl}/blade-tw-recruit/company/post/submit` // 发布岗位
export const postWithdrawUrl = `${baseUrl}/blade-tw-recruit/company/post/cancel` // 撤销岗位
export const postDetailUrl = `${baseUrl}/blade-tw-recruit/company/post/detail` // 岗位详情

/**
 * 人才库
 */
// export const talentListUrl = `${baseUrl}/blade-tw-recruit/company/talentPool/page` // 分页列表
export const talentListUrl = `${baseUrl}/blade-tw-recruit/company/talentPool/list` // 不分页的列表
export const cancelCollectUrl = `${baseUrl}/blade-tw-recruit/company/talentPool/unCollect` // 取消收藏 (需要登录状态下才能调用的接口)
export const collectionListUrl = `${baseUrl}/blade-tw-recruit/company/talentPool/collectionPage` // 我的收藏-分页查询
export const collectUrl = `${baseUrl}/blade-tw-recruit/company/talentPool/collect` // 收藏人才  (需要登录状态下才能调用的接口)
export const talentDetailUrl = `${baseUrl}/blade-tw-recruit/company/talentPool/resumeDetail` // 简历详情
export const inviteInterviewUrl = `${baseUrl}/blade-tw-recruit/company/talentPool/inviteInterview` // 邀请面试
export const resumeIdsUrl = `${baseUrl}/blade-tw-recruit/company/talentPool/listId` // 搜索全部简历id列表
export const resumeCollectIdsUrl = `${baseUrl}/blade-tw-recruit/company/talentPool/collectionIdList` // 人才库-我的收藏-获取全部收藏简历id列表

// export const recruitPostListUrl = `${baseUrl}/blade-tw-recruit/company/post/companyRecruitPostList` // 查询本企业正在招聘的岗位列表

/**
 * 求职简历
 */
export const resumeListUrl = `${baseUrl}/blade-tw-recruit/company/sendResume/page` // 分页列表
export const markNoPassUrl = `${baseUrl}/blade-tw-recruit/company/sendResume/markNotPass` // 标记不合适
export const markPassUrl = `${baseUrl}/blade-tw-recruit/company/sendResume/markPass` // 邀请面试
export const resumeDetailUrl = `${baseUrl}/blade-tw-recruit/company/sendResume/detail` // 求职简历详情
export const resumeCountUrl = `${baseUrl}/blade-tw-recruit/company/sendResume/sendResumeStatusCount` // 获取简历状态数量，如求职简历(10)
export const newResumeCountUrl = `${baseUrl}/blade-tw-recruit/company/sendResume/newestCount` // 获取新投递的简历数量，每隔几分钟获取一次
export const resumeRemoveUrl = `${baseUrl}/blade-tw-recruit/company/sendResume/remove` // 批量删除求职简历

/**
 * 面试管理
 */
export const interviewListUrl = `${baseUrl}/blade-tw-recruit/company/interview/page` // 分页列表
export const updateInterviewTimeUrl = `${baseUrl}/blade-tw-recruit/company/interview/updateInterviewTime` // 修改面试时间
export const feedbackUrl = `${baseUrl}/blade-tw-recruit/company/interview/feedback` // 面试反馈
export const cancelInterviewUrl = `${baseUrl}/blade-tw-recruit/company/interview/cancel` // 取消面试
export const interviewDetailUrl = `${baseUrl}/blade-tw-recruit/company/interview/detail` // 面试简历详情

/**
 * 人才库
 */
export const portalResumePageUrl = `${baseUrl}/blade-tw-recruit/common/portal/resume/page` // 分页列表
export const portalResumeDetailUrl = `${baseUrl}/blade-tw-recruit/common/portal/resume/detail` // 详情
export const portalResumeCollectUrl = `${baseUrl}/blade-tw-recruit/common/portal/resume/collect` // 搜索人才-收藏
export const portalResumeUnCollectUrl = `${baseUrl}/blade-tw-recruit/common/portal/resume/unCollect` // 搜索人才 - 取消收藏
export const resumeExportUrl = `${baseUrl}/blade-tw-recruit/common/portal/resume/export` // 导出简历

/**
 * 两岸人才会客厅
 */
export const talentReceptPageUrl = `${baseUrl}/blade-tw-recruit/common/portal/talent/reception/information/page` // 分页列表
export const talentReceptDetailUrl = `${baseUrl}/blade-tw-recruit/common/portal/talent/reception/information/detail` // 详情
export const talentReceptListByBriefUrl = `${baseUrl}/blade-tw-recruit/common/portal/talent/reception/information/listByBrief` // 全量简略数据
/**
 * 企业营业执照
 */
export const uploadBusinessLicenseUrl = `${baseUrl}/blade-tw-recruit/company/uploadBusinessLicense` // 上传营业执照
export const getBusinessLicenseUrl = `${baseUrl}/blade-tw-recruit/company/getBusinessLicense` // 获取企业营业执照

/**
 * 企业风采
 */
export const getCompanyStyleUrl = `${baseUrl}/blade-tw-recruit/administrator/company/getCompanyStyle` // 获取企业风采
export const uploadCompanyStyleUrl = `${baseUrl}/blade-tw-recruit/company/uploadCompanyStyle` // 上传企业风采
export const removeCompanyStyleUrl = `${baseUrl}/blade-tw-recruit/company/removeCompanyStyle` // 删除企业风采

/**
 * 个人中心
 */
const individualPre = `${baseUrl}/blade-tw-recruit/individual/`
export const individualDetailUrl = `${individualPre}account/detail` // 个人信息
export const individualUpdateUrl = `${individualPre}account/updateAccountDetail` // 修改个人信息
export const individualUploadAvatarUrl = `${individualPre}account/uploadAvatar` // 上传头像

/**
 * 我的简历
 */
export const myResumeDetailUrl = `${baseUrl}/blade-tw-recruit/individual/resume/resumeDetail` // 查看简历详情
export const resumeHiddenUrl = `${baseUrl}/blade-tw-recruit/individual/resume/hideResume` // 设置简历是否屏蔽
export const hiddenCompanyUrl = `${baseUrl}/blade-tw-recruit/individual/resume/hideForCompany` // 设置屏蔽企业
export const hiddenCompanyListUrl = `${baseUrl}/blade-tw-recruit/individual/resume/findHideCompanyList` // 查看当前屏蔽的企业列表
export const companyListUrl = `${baseUrl}/blade-tw-recruit/individual/resume/findCompanyByName` // 查询企业信息，用于简历屏蔽企业功能
export const myResumeListUrl = `${baseUrl}/blade-tw-recruit/individual/resume/findAccountResumes` // 查找登录用户的所有简历
export const saveWorkUrl = `${baseUrl}/blade-tw-recruit/individual/resume/editWorkExperience` // 编辑工作经历
export const saveTrainUrl = `${baseUrl}/blade-tw-recruit/individual/resume/editTrainingExperience` // 编辑培训经历
export const saveCertificateUrl = `${baseUrl}/blade-tw-recruit/individual/resume/editSkillsCertificate` // 编辑技能证书
export const saveIntroduceUrl = `${baseUrl}/blade-tw-recruit/individual/resume/editSelfIntroduction` // 编辑自我介绍
export const saveResumeUrl = `${baseUrl}/blade-tw-recruit/individual/resume/editResume` // 新增或修改简历
export const saveProjectUrl = `${baseUrl}/blade-tw-recruit/individual/resume/editProjectExperience` // 编辑项目经验
export const saveEducationUrl = `${baseUrl}/blade-tw-recruit/individual/resume/editEducationExperience` // 编辑教育经历
export const saveTrainingUrl = `${baseUrl}/blade-tw-recruit/individual/resume/editTrainingExperience` // 编辑培训经历
export const editDetailUrl = `${baseUrl}/blade-tw-recruit/individual/resume/editDetail` // 编辑个人基本详情
export const saveObjectiveUrl = `${baseUrl}/blade-tw-recruit/individual/resume/editCareerObjective` // 编辑求职意向
export const removeWorkUrl = `${baseUrl}/blade-tw-recruit/individual/resume/delWorkExperience` // 删除工作经历
export const removeTrainUrl = `${baseUrl}/blade-tw-recruit/individual/resume/delTrainingExperience` // 删除培训经历
export const removeCertificateUrl = `${baseUrl}/blade-tw-recruit/individual/resume/delSkillsCertificate` // 删除技能证书
export const removeResumeUrl = `${baseUrl}/blade-tw-recruit/individual/resume/delResume` // 删除个人简历
export const removeProjectUrl = `${baseUrl}/blade-tw-recruit/individual/resume/delProjectExperience` // 删除项目经历
export const removeEducationUrl = `${baseUrl}/blade-tw-recruit/individual/resume/delEducationExperience` // 删除教育经历
export const removeTrainingUrl = `${baseUrl}/blade-tw-recruit/individual/resume/delTrainingExperience` // 删除培训经历
export const changeAvatarUrl = `${baseUrl}/blade-tw-recruit/individual/resume/changeProfilePhoto` // 更换头像

/**
 * 我的简历 草稿
 */
export const resumeDraftCreateUrl = `${baseUrl}/blade-tw-recruit/individual/resumeDraft/createDraft` // 创建草稿
export const resumeDraftDetailUrl = `${baseUrl}/blade-tw-recruit/individual/resumeDraft/resumeDetail` // 草稿详情
export const resumeDraftNameEditUrl = `${baseUrl}/blade-tw-recruit/individual/resumeDraft/updateResumeName` // 编辑简历名称
export const resumeDraftDetailEditUrl = `${baseUrl}/blade-tw-recruit/individual/resumeDraft/editDetail` // 编辑个人基本详情
export const saveDraftObjectiveUrl = `${baseUrl}/blade-tw-recruit/individual/resumeDraft/editCareerObjective` // 编辑求职意向
export const saveDraftWorkUrl = `${baseUrl}/blade-tw-recruit/individual/resumeDraft/editWorkExperience` // 编辑工作经历
export const saveDraftProjectUrl = `${baseUrl}/blade-tw-recruit/individual/resumeDraft/editProjectExperience` // 编辑项目经验
export const saveDraftEducationUrl = `${baseUrl}/blade-tw-recruit/individual/resumeDraft/editEducationExperience` // 编辑教育经历
export const saveDraftTrainingUrl = `${baseUrl}/blade-tw-recruit/individual/resumeDraft/editTrainingExperience` // 编辑培训经历
export const saveDraftCertificateUrl = `${baseUrl}/blade-tw-recruit/individual/resumeDraft/editSkillsCertificate` // 编辑技能证书
export const saveDraftIntroduceUrl = `${baseUrl}/blade-tw-recruit/individual/resumeDraft/editSelfIntroduction` // 编辑自我介绍

export const removeDraftWorkUrl = `${baseUrl}/blade-tw-recruit/individual/resumeDraft/delWorkExperience` // 删除工作经历
export const removeDraftTrainUrl = `${baseUrl}/blade-tw-recruit/individual/resumeDraft/delTrainingExperience` // 删除培训经历
export const removeDraftCertificateUrl = `${baseUrl}/blade-tw-recruit/individual/resumeDraft/delSkillsCertificate` // 删除技能证书
// export const removeDraftResumeUrl = `${baseUrl}/blade-tw-recruit/individual/resumeDraft/delResume` // 删除个人简历
export const removeDraftProjectUrl = `${baseUrl}/blade-tw-recruit/individual/resumeDraft/delProjectExperience` // 删除项目经历
export const removeDraftEducationUrl = `${baseUrl}/blade-tw-recruit/individual/resumeDraft/delEducationExperience` // 删除教育经历
export const changeDraftAvatarUrl = `${baseUrl}/blade-tw-recruit/individual/resumeDraft/changeProfilePhoto` // 更换头像
export const draftSubmitUrl = `${baseUrl}/blade-tw-recruit/individual/resumeDraft/submitAudit` // 提交审核
export const draftUndoUrl = `${baseUrl}/blade-tw-recruit/individual/resumeDraft/undoAudit` // 撤销审核

/**
 * 投递记录
 */
export const deliveryRecordListUrl = `${baseUrl}/blade-tw-recruit/individual/feedback/page` // 投递记录分页列表
export const acceptInterviewUrl = `${baseUrl}/blade-tw-recruit/individual/feedback/acceptInterview` // 接受面试
export const refuseInterviewUrl = `${baseUrl}/blade-tw-recruit/individual/feedback/refuseInterview` // 拒绝面试
export const cancelMyInterviewUrl = `${baseUrl}/blade-tw-recruit/individual/feedback/cancelInterview` // 取消面试

/**
 * 我的收藏
 */
export const postcollectPageUrl = `${individualPre}post/collectPage` // 我的收藏 - 岗位分页列表
export const cancelPostCollectUrl = `${baseUrl}/blade-tw-recruit/individual/post/cancelCollect` // 取消岗位收藏

export const resumeBeViewedPageUrl = `${individualPre}resume/beViewedPage` // 被查看的公司分页

/**
 * 台青地图
 */
export const getStatisticsByStreetNameUrl = `${baseUrl}/blade-tw-recruit/common/portal/map/getStatisticsByStreetName` // 获取街道名称统计数据
export const getTotalStatisticsUrl = `${baseUrl}/blade-tw-recruit/common/portal/map/getTotalStatistics` // 获取全部的统计数据
export const getStatisticsByIndustryCodeUrl = `${baseUrl}/blade-tw-recruit/common/portal/map/getStatisticsByIndustryCode` // 获取行业统计数据

/**
 * 创业
 */
export const entrepreneurshipTypeListUrl = `${baseUrl}/blade-tw-recruit/common/portal/entrepreneurshipType/list` // 创业类型列表
export const entrepreneurshipPageUrl = `${baseUrl}/blade-tw-recruit/common/portal/entrepreneurship/page` // 创业分页
export const entrepreneurshipDetailUrl = `${baseUrl}/blade-tw-recruit/common/portal/entrepreneurship/detail` // 创业详情
export const entrepreneurshipListByBriefUrl = `${baseUrl}/blade-tw-recruit/common/portal/entrepreneurship/listByBrief` // 全量简略数据

/**
 * 联系我们
 */
export const contactUsDetailUrl = `${baseUrl}/blade-tw-recruit/common/portal/contactUs/detail` // 联系我们详情
